import React from 'react'

import { GuestIcon } from '@toasttab/buffet-pui-icons'
import { CountryCode } from 'libphonenumber-js'

import PhoneLink from 'src/shared/components/common/link/PhoneLink'

import { t } from 'src/translations'

type DeliveryDriverInfoType = {
  driverName: string
  driverPhotoUrl: string | null | undefined
  driverNumber: string | null | undefined
}

export type DeliveryDriverInfoProps = {
  driverInfo?: DeliveryDriverInfoType
  countryCode?: CountryCode
}

const DeliveryDriverInfo = ({
  driverInfo,
  countryCode
}: DeliveryDriverInfoProps) => {
  if (!driverInfo) return <NoDriver />

  const { driverName, driverNumber, driverPhotoUrl } = driverInfo

  return (
    <div data-testid='driver-info'>
      <div className='driverProfile'>
        {driverPhotoUrl ? (
          <img
            className='driverPhoto'
            alt={t('delivery-driver-info.driver-photo')}
            src={driverPhotoUrl}
          />
        ) : (
          <GuestIcon />
        )}
        <div className='driverName'>{driverName}</div>
      </div>
      <div className='copy'>{t('delivery-driver-info.you-can-tell')}</div>
      {/* phone */}
      {driverNumber && (
        <PhoneLink
          className='linkText phone'
          phoneNumber={driverNumber}
          countryCode={countryCode ?? 'US'}
        />
      )}
    </div>
  )
}

const NoDriver = () => (
  <div data-testid='no-driver' className='noDriver'>
    {/* icon */}
    <div className='icon'>
      <GuestIcon />
    </div>
    {/* copy */}
    <div className='info'>
      <div className='driverName' style={{ fontWeight: 'bold' }}>
        {t('delivery-driver-info.driver-will')}
      </div>
      <div className='copy'>{t('delivery-driver-info.a-driver-will')}</div>
    </div>
  </div>
)

export default DeliveryDriverInfo
